import { $, api, appState } from './app-state';

function updateRemoteClipboardButton(): void {
  const button = $('tb-copy') as HTMLButtonElement;
  const label = button.querySelector('span');
  const pending = appState.pendingRemoteClipboard !== null;
  button.classList.toggle('active', pending);
  button.title = pending
    ? '远端内容已到达，点击完成复制到本机'
    : '复制远端剪贴板到本机';
  if (label) label.textContent = pending ? '完成复制' : '复制';
}

function clearPendingRemoteClipboard(): void {
  // 使尚未完成的自动写入失效，避免旧会话的异步结果覆盖新会话状态。
  appState.remoteClipboardRevision += 1;
  appState.pendingRemoteClipboard = null;
  updateRemoteClipboardButton();
}

async function copyRemoteClipboard(): Promise<void> {
  if (!appState.controller || appState.clipboardWriteBusy) return;

  // Web 页面收到 WebRTC 消息时通常已经不在用户手势上下文中；如果浏览器
  // 拒绝自动写入，第二次点击会在真实用户手势内重试，不需要弹窗或复制框。
  if (appState.pendingRemoteClipboard !== null) {
    appState.clipboardWriteBusy = true;
    try {
      const copied = await api.writeClipboard(appState.pendingRemoteClipboard);
      if (copied) {
        clearPendingRemoteClipboard();
        $('session-status').textContent = '远端内容已复制到本机';
      } else {
        $('session-status').textContent = '浏览器仍未授权剪贴板，请再次点击“完成复制”';
      }
    } finally {
      appState.clipboardWriteBusy = false;
    }
    return;
  }

  $('session-status').textContent = '正在获取远端剪贴板…';
  appState.controller.requestRemoteClipboard();
}

export { updateRemoteClipboardButton, clearPendingRemoteClipboard, copyRemoteClipboard };
